import script from "./OverlayMsgCom.vue?vue&type=script&setup=true&lang=js"
export * from "./OverlayMsgCom.vue?vue&type=script&setup=true&lang=js"

import "./OverlayMsgCom.vue?vue&type=style&index=0&id=8d31f864&lang=css"

const __exports__ = script;

export default __exports__